import React, { useRef, useEffect, useCallback } from 'react';
import { func, object, bool } from 'prop-types';
import { Form } from 'react-bootstrap';
import '../styles/PageForm.css';

const TEXT_AREA = 'textarea';
const FILE_TYPE = 'file';
const FILES_SUFFIX = '-files';

function PageFormField({ field, data, setData, formSubmitted, setFormSubmitted }) {
    const { id, label, type, controlId, required } = field;
    const fileInputRef = useRef(null);

    const handleFileChange = useCallback((e) => {
        setData({
            ... data,
            [`${id}${FILES_SUFFIX}`]: e.target.files,
        });
    }, [data, id, setData]);

    const handleTextChange = useCallback((e) => {
        setData({
            ... data,
            [id]: e.target.value,
        });
    }, [data, id, setData]);

    // Clear file input value after form submission
    useEffect(() => {
        if (formSubmitted && type === FILE_TYPE) {
            fileInputRef.current.value = '';
            setFormSubmitted(false);
        }
    }, [formSubmitted, type]);

    return (
        <Form.Group
            key={id}
            className={'mb-3'}
            controlId={controlId}
            style={{ flexGrow: 1 }}
        >
            <Form.Label>{label}</Form.Label>
            {required ? (
                <span
                    className={'text-danger'}
                >
                    *
                </span>
            ) : null}
            {type === FILE_TYPE ? (
                <Form.Control
                    ref={fileInputRef}
                    type={type}
                    multiple
                    required={required}
                    className={'page-form--field'}
                    onChange={handleFileChange}
                />
            ): (
                <Form.Control
                    as={type === TEXT_AREA ? TEXT_AREA : undefined}
                    type={type}
                    required={required}
                    placeholder={`Enter ${label}...`}
                    value={data[id]}
                    className={'page-form--field'}
                    onChange={handleTextChange}
                />
            )}
        </Form.Group>
    );
}

PageFormField.propTypes = {
    field: object,
    data: object,
    setData: func,
    formSubmitted: bool,
    setFormSubmitted: func,
};

export default PageFormField;